import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/ui/formrowview
 */
import { View } from 'ckeditor5/src/ui.js';
import '../../theme/formrow.css';
/**
 * The class representing a single row in a complex form,
 * used by {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView}.
 *
 * **Note**: For now this class is private. When more use cases arrive (beyond ckeditor5-table),
 * it will become a component in ckeditor5-ui.
 *
 * @internal
 */
var FormRowView = /*#__PURE__*/function (_View) {
  _inherits(FormRowView, _View);
  var _super = _createSuper(FormRowView);
  /**
   * Creates an instance of the form row class.
   *
   * @param locale The locale instance.
   * @param options.labelView When passed, the row gets the `group` and `aria-labelledby`
   * DOM attributes and gets described by the label.
   */
  function FormRowView(locale) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, FormRowView);
    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    _this.set('class', options.class || null);
    _this.children = _this.createCollection();
    if (options.children) {
      options.children.forEach(function (child) {
        return _this.children.add(child);
      });
    }
    _this.set('_role', null);
    _this.set('_ariaLabelledBy', null);
    if (options.labelView) {
      _this.set({
        _role: 'group',
        _ariaLabelledBy: options.labelView.id
      });
    }
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-form__row', bind.to('class')],
        role: bind.to('_role'),
        'aria-labelledby': bind.to('_ariaLabelledBy')
      },
      children: _this.children
    });
    return _this;
  }
  return FormRowView;
}(View);
export { FormRowView as default };